class n {
  static showImage(e, s, o, i) {
    let t;
    if (i || !(e instanceof HTMLImageElement) ? t = (a) => e.style.backgroundImage = this.prepareSrc(a) : t = (a) => e.src = a, t(o), s) {
      const a = () => {
        t(s);
      }, r = new Image();
      r.addEventListener("load", a), r.src = s, r.complete && (r.removeEventListener("load", a), a());
    }
  }
  static prepareSrc(e) {
    return e ? e.startsWith("url") ? e : `url("${e}")` : null;
  }
}
export {
  n as default
};
//# sourceMappingURL=image-tools.mjs.map
